<template>
    <div>
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form @submit.prevent="register" @keydown="form.onKeydown($event)">
          <v-card-title primary-title>
            <h3 class="headline mb-0">Add User</h3>
          </v-card-title>
          <v-card-text>

            <!-- Name -->
            <text-input
              :form="form"
              :label="$t('name')"
              :v-errors="errors"
              :value.sync="form.name"
              browser-autocomplete="name"
              counter="30"
              name="name"
              v-validate="'required|max:30'"
            ></text-input>

            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              v-validate="'required|email'"
            ></email-input>

            <!-- Password -->
            <password-input
              :form="form"
              :hint="$t('password_length_hint')"
              :v-errors="errors"
              :value.sync="form.password"
              browser-autocomplete="new-password"
              v-on:eye="eye = $event"
              name="password"
              v-validate="'required|min:8'"
            ></password-input>

            <!-- Password Confirmation -->
            <password-input
              :form="form"
              :hide="eye"
              :label="$t('confirm_password')"
              :v-errors="errors"
              :value.sync="form.password_confirmation"
              browser-autocomplete="new-password"
              data-vv-as="password"
              hide-icon="true"
              name="password_confirmation"
              v-validate="'required:password'"
            ></password-input>

          </v-card-text>

          <v-card-actions>
            <submit-button :form="form" :label="$t('register')"></submit-button>
          </v-card-actions>
        </form>
      </v-card>
    </div>
</template>

<script>
  import Vue from "vue";
  import Axios from "axios";
  import Form from 'vform'

  export default {
      data: () => ({
    form: new Form({
      name: '',
      email: '',
      password: '',
      password_confirmation: ''
    }),
    eye: true
  }),
    methods: {

      async register () {
      if (await this.formHasErrors()) return

      // Register the user.
      const { data } = await this.form.post('/api/register')

    }
    },
    mounted() {
      this.model.name = user.name;
      window.onbeforeunload = () => {
        return "Hey, are you want sure want to unload the page? This may cause a loss of unsaved information.";
      };
    }
  };
</script>

<style>

    .fileContainer [type="file"] {
        cursor: inherit;
        display: block;
        filter: alpha(opacity=0);
        min-height: 100%;
        min-width: 100%;
        opacity: 0;
        position: absolute;
        right: 0;
        text-align: right;
        top: 0;
    }
    .ve-select span {
        font-size: 14px;
    }

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/users/create.vue